import clsx from 'clsx';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { Card } from '../components/sections/Card';
import { Illustration } from '../components/decoration/Illustrations';

export const DecorativeCard: FC<PropsWithChildren<HTMLAttributes<HTMLDivElement>>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div className="h-full w-full bg-gradient-to-br from-slate-50 to-gray-100 flex items-center justify-center px-8">
      <div className="relative left-4 z-10 hidden md:inline">
        <Illustration />
      </div>
      <Card className={clsx('relative shadow-xl md:-left-4', className)} {...props}>
        {children}
      </Card>
    </div>
  );
};
